import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const PROVIDER_MODELS = {
  gemini: { label: "Gemini", models: ["gemini-3.1-pro-preview", "gemini-3-flash-preview", "gemini-3.5-flash", "gemini-2.5-pro"] },
  anthropic: { label: "Claude", models: ["claude-sonnet-5-5", "claude-sonnet-5", "claude-opus-5-5", "claude-haiku-4-5-20251001"] },
  openai: { label: "OpenAI", models: ["gpt-5.6-terra", "gpt-5.6-luna", "gpt-5.6-sol", "gpt-5.6"] },
};
export const DEFAULT_PICK = { provider: "gemini", model: "gemini-3.1-pro-preview" };

export function AiModelPicker({ value, onChange, testid = "ai-pick", className = "" }) {
  const v = value || DEFAULT_PICK;
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid={testid}>
      <Select value={v.provider} onValueChange={(p) => onChange({ provider: p, model: PROVIDER_MODELS[p].models[0] })}>
        <SelectTrigger data-testid={`${testid}-provider`} className="bg-zinc-950 border-zinc-800 h-8 text-xs w-[110px]"><SelectValue /></SelectTrigger>
        <SelectContent>{Object.entries(PROVIDER_MODELS).map(([k, p]) => <SelectItem key={k} value={k}>{p.label}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={v.model} onValueChange={(m) => onChange({ ...v, model: m })}>
        <SelectTrigger data-testid={`${testid}-model`} className="bg-zinc-950 border-zinc-800 h-8 text-xs w-[150px] font-mono"><SelectValue /></SelectTrigger>
        <SelectContent>{PROVIDER_MODELS[v.provider].models.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}
